package org.lennycodes.hldi.styles
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.dom.svg.Defs
import com.varabyte.kobweb.compose.dom.svg.LinearGradient
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Stop
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.dom.svg.SvgId
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
val SectionWaveSvgStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block) // kills the inline baseline gap
            .position(Position.Absolute)
            .width(100.percent)
            .height(80.px)
            .styleModifier {
                property("bottom", "-2px")
                property("left", "0")
                property("transform", "translateY(100%) scaleY(-1)")
            }
    }
}

@Composable
fun SectionWaveSvg() {
    Svg(
        attrs = SectionWaveSvgStyle.toAttrs {
            attr("viewBox", "0 0 1440 120")
            attr("preserveAspectRatio", "none")
        }
    ) {
        Defs {
            LinearGradient(
                id = SvgId("section"),
                attrs = {
                    id("waveGradient")
                    attr("x1", "0%")
                    attr("y1", "0%")
                    attr("x2", "100%")
                    attr("y2", "100%") // roughly mirrors the 135deg direction of your CSS gradient
                }
            ) {
                Stop(attrs = {
                    attr("offset", "0%")
                    attr("stop-color", HLDITheme.Colors.primary.toString())
                })
                Stop(attrs = {
                    attr("offset", "100%")
                    attr("stop-color", HLDITheme.Colors.secondary.toString())
                })
            }
        }
        Path(
            attrs = {
                attr("fill", "url(#waveGradient)")
                attr("d", "M0,64 C240,120 480,0 720,32 C960,64 1200,120 1440,64 L1440,120 L0,120 Z")
            }
        )
    }
}